import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import React, { useContext, useState } from "react";
import {
  dashboardRemove,
  zoneRemove,
  removeLearnApi,
  scenarioDelete,
  addNewScenario,
} from "../api";
import { removeDashboard, removeZone } from "../redux";
import { withRouter } from "react-router-dom";
import { ScenarioSection } from "../context/ScenarioContext";
import { useTranslation } from "react-i18next";
import { FiCheck, FiX, FiAlertCircle } from "react-icons/fi";

const AlertComp = (props) => {
  const { t } = useTranslation();
  const {
    message,
    type,
    question,
    id,
    request,
    toggleAlert,
    serial,
    closeModal,
    title,
    icon,
    uid,
    setScenarioId,
    deviceSerial,
    setSubmitAlert,
    setIdd,
  } = props;
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const { ShowHideFunction } = useContext(ScenarioSection);
  const [showToast, setShowToast] = useState(false);
  const [tooltipText, setTooltipText] = useState("");
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const submitHandler = () => {
    const data = new FormData();
    if (request === "dashboard") {
      data.append("dashboard", id);
      dashboardRemove(data, token)
        .then((res) => {
          dispatch(removeDashboard({ id: id }));
          toggleAlert();
        })
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
          }
        });
    } else if (request === "zone") {
      data.append("zone", id);
      zoneRemove(data, token)
        .then(() => {
          dispatch(removeZone({ id: id }));
          toggleAlert();
        })
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
          }
        });
    } else if (request === "deleteLearn") {
      data.append("serial", serial);
      data.append("widget", id);
      removeLearnApi(data, token)
        .then((res) => {
          toggleAlert();
        })
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
          }
        });
    } else if (request === "deleteScenario") {
      const data = new FormData();
      data.append("scenario_id", id);
      scenarioDelete(data, token)
        .then((result) => {})
        .catch((err) => {
          if (err.response.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
            setShowAlert({
              show: true,
              message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
              type: "Error",
            });
            setTimeout(() => {
              setShowAlert((prev) => ({ ...prev, show: false }));
            }, 2000);
          }
        });
      setShowAlert({
        show: true,
        question: false,
        message: t(" با موفقیت حذف شد."),
        type: "Success",
      });
      setTimeout(() => {
        setShowAlert(() => ({ show: false }));
        toggleAlert();
        closeModal(false);
      }, 2000);
    } else if (request === "addNewScenario") {
      const data = new FormData();
      data.append("title", title);
      data.append("icon", icon);
      addNewScenario(data, token)
        .then((result) => {
          setScenarioId(result.data.data);
          setShowAlert({
            show: true,
            question: false,
            message: t("با موفقیت اضافه شد."),
            type: "Success",
          });
          setTimeout(() => {
            setShowAlert(() => ({ show: false }));
            toggleAlert();
            ShowHideFunction("firstPage");
          }, 2000);
        })
        .catch((err) => {
          if (err.response.status === 400) {
            setShowAlert({
              show: true,
              question: false,
              message: t("با موفقیت اضافه شد."),
              type: "Error",
            });
            setTimeout(() => {
              setShowAlert(() => ({ show: false }));
              toggleAlert();
              ShowHideFunction("firstPage");
            }, 3000);
          }
        });
    } else if (request === "DeleteDeviceDisjoint") {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      var formdata = new FormData();
      formdata.append("serial", deviceSerial);
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };
      fetch("https://assessn.mmaviot.com/api/device_disjoin", requestOptions)
        .then((response) => response.text())
        .then((res) => {
          setShowAlert({
            show: true,
            question: false,
            message: t(" با موفقیت حذف شد."),
            type: "Success",
          });
          setTimeout(() => {
            setShowAlert(() => ({ show: false }));
            toggleAlert(true);
          }, 3000);
        })
        .catch((error) => console.log("error", error));
    }
  };

const cancelHandler = () => {
  if (toggleAlert && typeof toggleAlert === 'function') {
    toggleAlert();
  }
};

  const getAlertIcon = () => {
    if (type === "Success") return <FiCheck size={20} />;
    if (type === "Error") return <FiX size={20} />;
    return <FiAlertCircle size={20} />;
  };

  const getAlertClass = () => {
    if (type === "Success") return "alert-setting-success";
    if (type === "Error") return "alert-setting-error";
    return "alert-setting-warning";
  };

  return (
    <>
      {tooltipText && <div className="toast-tooltip w-75">{tooltipText}</div>}
      
      <div className="alert-setting-overlay" onClick={cancelHandler}>
        <div className={`alert-setting-container ${getAlertClass()}`} onClick={(e) => e.stopPropagation()}>
          <div className="alert-setting-icon">
            {getAlertIcon()}
          </div>
          <p className="alert-setting-message">{message}</p>
          
          {question ? (
            <div className="alert-setting-buttons">
              <button className="alert-setting-btn-cancel" onClick={cancelHandler}>
                <FiX size={16} />
                <span>{t("خیر")}</span>
              </button>
              <button className="alert-setting-btn-confirm" onClick={submitHandler}>
                <FiCheck size={16} />
                <span>{t("بله")}</span>
              </button>
            </div>
          ) : (
            <button className="alert-setting-btn-close" onClick={cancelHandler}>
              <FiX size={16} />
              <span>{t("باشه")}</span>
            </button>
          )}
        </div>
      </div>

      {showAlert.show && (
        <Alert
          message={showAlert.message}
          type={showAlert.type}
          title={title}
          icon={icon}
          setScenarioId={setScenarioId}
          question={showAlert.question}
          request={showAlert.request}
          toggleAlert={toggleAlert}
        />
      )}
    </>
  );
};

const Alert = withRouter(AlertComp);

export { Alert };